import { render, staticRenderFns } from "./filterStrategy.vue?vue&type=template&id=3087a2e9&scoped=true&"
import script from "./filterStrategy.vue?vue&type=script&lang=js&"
export * from "./filterStrategy.vue?vue&type=script&lang=js&"
import style0 from "./filterStrategy.vue?vue&type=style&index=0&id=3087a2e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3087a2e9",
  null
  
)

export default component.exports